@let reviewForm = form();

<div [formGroup]="reviewForm">
  <app-pan-form-control>
    <app-pan-floating-label for="additionalStolenValue"> Additional Value of Items Taken ($)</app-pan-floating-label>
    <input
      panInput
      panNumericInput
      id="additionalStolenValue"
      formControlName="additionalStolenValue"
      placeholder="0"
      min="0"
      type="number"
      data-testid="additionalStolenValue"
    />
  </app-pan-form-control>
</div>
